export default __webpack_public_path__ + "static/media/thank.a35e482a.svg";